import { BaseEntity, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'food-group',
})
export default class FoodGroup extends BaseEntity {
  name: string = '';

  public constructor(id?: string) {
    super();
    this.id = id;
  }
}
